import WhatsappLeadAssignmentTab from './lead-assignment-wapp';

export default WhatsappLeadAssignmentTab;
